import { useStaticQuery, graphql } from "gatsby";

export const GetBrandsData = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpBrands {
        nodes {
          brandName
          brandDetail
          brandLogo {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `);
  return data.allWpBrands.nodes;
};
